export class IpTools {
  public static Netmask(prefixLength: number): string {

    if (isNaN(prefixLength) || prefixLength < 0 || prefixLength > 32) {
      return '-';
    }

    const mask = [];
    for (let i = 0; i < 4; i++) {
      const n = Math.min(prefixLength, 8);
      mask.push(256 - Math.pow(2, 8 - n));
      prefixLength -= n;
    }

    return mask.join('.');
  }

  public static IntToIp4(ipInt: number): string {
    // tslint:disable-next-line:no-bitwise
    return ((ipInt >>> 24) + '.' + (ipInt >> 16 & 255) + '.' + (ipInt >> 8 & 255) + '.' + (ipInt & 255));
  }

  public static Ip4ToInt(ip: string): number {
    return ip.split('.').reduce(
      // tslint:disable-next-line:no-bitwise
      (ipInt, octet) => (ipInt << 8) + parseInt(octet, 10),
      0,
    ) >>> 0;
  }
}
